import { z } from "zod";

export const UpsertEventGateSchema = z.object({
  id: z.string().optional(),
  name: z
    .string()
    .min(1, "Le nom de la porte est requis")
    .max(64, "Le nom de la porte ne doit pas dépasser 64 caractères"),
  ticketTypes: z.array(z.string()).optional(),
  badgeTypes: z.array(z.string()).optional(),
});

export type UpsertEventGateForm = z.infer<typeof UpsertEventGateSchema>;

export const defaultUpsertEventGateValues: UpsertEventGateForm = {
  id: undefined,
  name: "",
  ticketTypes: [],
  badgeTypes: [],
};
